import { render, staticRenderFns } from "./PEPageChanger.vue?vue&type=template&id=78adca63"
import script from "./PEPageChanger.vue?vue&type=script&lang=js"
export * from "./PEPageChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports